<template>
  <div class="extra-card">
    <div class="extra--wrapper">
      <div class="extra-header">
        <span v-if="!!promoLabel" class="promo-label">{{promoLabel}}</span>
        <div class="btnsee" @click="handleClickInfo"></div>
        <img v-lazy="`${picture}`">
      </div>
      <div class="infoextra"><h6 class="no-wrap">{{name}}</h6>
        <div class="price">{{price | decimalPrice}} € {{type}}</div>
        <div class="addextra" @click="handleClickAdd" v-if="!isSelected">+ Ajouter</div>
        <div class="addextra add-extra--reverse" @click="handleClickAdd" v-else-if="!needRemoveBtn">Modifier</div>
        <div class="addextra add-extra--reverse" @click="handleClickRemove" v-else>- Retirer</div>
      </div>
    </div>
    <card-extra-picker
      :extra="item"
      :start-date="startDate"
      :end-date="endDate"
      :nb-guest="nbGuest"
      ref="picker"
      v-on:extra-change="handleExtraChange"
    />
  </div>
</template>

<script>
  import ExtraMainWidget from './extra-main-widget'

  export default {
    name: "extra-second-widget",
    extends: ExtraMainWidget,
  }
</script>

<style scoped>

  ul.allextras li .infoextra {
    width: 100%!important;
    padding: 1rem!important;
    text-align: center;
  }
  ul.allextras li .infoextra .price {
    display: block;
    width: 100%;
    text-align: center;
  }

  ul.allextras li .infoextra .addextra {
    position: absolute;
    bottom: 1rem;
    margin: 0;
    left: calc(50% - 50px);
  }

  ul.allextras li .infoextra h6 {
    float: none!important;
    height: 24px;
  }

  .extra-card {
    border-radius: 8px;
    overflow: hidden;
    position: relative;
  }

  .extra--wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 50% 50%;
    height: 100%;
    grid-gap: 0;
    width: 100%;
  }

  .infoextra {
    margin: auto 0 0 0;
    flex: 0 0 auto;
    float: none !important;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  .extra-header {
    position: relative;
    overflow: hidden;
  }

  .extra-header img {
    object-fit: fill;
    min-height: 100%;
    width: 100%;
  }

  .no-wrap {
    width: 100%;
    white-space: nowrap;
    word-wrap: unset;
    overflow-wrap: unset;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/pages/tunnel/step3/extra-second-widget.vue